<template>
  <div class="box-item">
    <div class="content" :class="typeItem">
      <div class="badge"></div>
      <h4> {{ titlebox }} </h4>
      <p><slot></slot></p>
      <bouton :href="lien"></bouton>
    </div> 
  </div> 
</template>

<script>
  import Bouton from '@/components/Bouton'
  export default {
    components: { Bouton },
    props: ['lien', 'titlebox', 'typeItem']
  }
</script>

<style>
  .box-item {
    border: 3px dashed #ccc;
    border-radius: 25px;
    padding: 20px;
    margin-bottom: 40px;
  }
  .box-item .content  {
    width: 100%;
    background: white;
    border-radius: 15px;
    padding: 25px 35px;
    box-shadow: 10px 10px 15px rgba(0,0,0,0.2); 
    text-align: center;
    min-height: 400px;
  }
  .box-item .badge {
    display: inline-block;
    background: #de2128;
    border: 4px solid #7f0004;
    width: 125px;
    height: 125px;
    border-radius: 150px;
    color: white; 
    font-size: 48px;
    margin-top: -65px;
    margin-bottom: 25px;
    text-align: center;
    padding: 24px;
  }
  .box-item .badge:before {
    content: "\f02d";
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    position: relative;
    font-weight: 900;
  }
  .box-item h4  {  
    font-size: 21px;
    color: #413492;
    line-height: 24px;
    margin-bottom: 20px;
    margin-top: 0px;
  }
  .box-item p  {  font-size: 14px; }
  .box-item .button:before { 
    content: 'Lire le document';
    display: inline-block;
    }
  
  .box-item .bd .badge {  background: #086fab; border-color: #403592;  }
  .box-item .bd .badge:before { content: "\f086"; }
  .box-item .bd .button {  background: #086fab;  box-shadow: 0px 8px 0px 0px #403592; }
  .box-item .bd .button:hover { box-shadow: 0px 0px 0px 0px #403592; }
  .box-item .bd .button:before { content: "Lire la BD"; }
  
  .box-item .article .badge:before { content: "\f1c5"; }
  .box-item .article .button:before { content: "Lire le document illustré"; }
  
  .box-item .video .badge {  background: #e3e039; border-color: #c2b81b;  }
  .box-item .video .badge:before { content: "\f144";color: #414141;}
  .box-item .video .button {  background: #e3e039;  box-shadow: 0px 8px 0px 0px #c2b81b;color: #414141; }
  .box-item .video .button:hover {  box-shadow: 0px 0px 0px 0px #c2b81b; }
  .box-item .video .button:before { content: "Voir la vidéo"; }
  
  .box-item .game .badge {  background: #e3e039; border-color: #c2b81b;  }
  .box-item .game .badge:before { content: "\f005";color: #414141;}
  .box-item .game .button {  background: #e3e039;  box-shadow: 0px 8px 0px 0px #c2b81b;color: #414141; }
  .box-item .game .button:hover {  box-shadow: 0px 0px 0px 0px #c2b81b; }
  .box-item .game .button:before { content: "Voir le jeu"; }
    
</style>
